<template>
    <node-view-wrapper as="span" class="image-container">
        <img v-bind="node.attrs" ref="resizableImg" :draggable="isDraggable" :data-drag-handle="isDraggable" />
        <b-icon icon="arrows-move" class="resize-icon hidden" ref="icon" @mousedown="onMouseDown"></b-icon>
    </node-view-wrapper>
</template>

<script lang="js">
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';

export default {
    components: {
        NodeViewWrapper
    },
    props: nodeViewProps,
    data() {
        return {
            isResizing: false,
            lastMovement: {},
            count: 0,
        };
    },

    computed: {
        // The isDraggable attr from 'resizable-image.js'
        isDraggable() {
            return this.node?.attrs?.isDraggable;
        },
    },

    mounted() {
        /* // When the image has loaded
        this.$refs.resizableImg.onload = () => {
            // Aspect Ratio from its original size
            this.aspectRatio = this.$refs.resizableImg.naturalWidth / this.$refs.resizableImg.naturalHeight;
            this.width = this.$refs.resizableImg.width;
            this.height = this.$refs.resizableImg.height;
        };

        // On mouse down, start resizing
        this.$refs.resizableImg.addEventListener('mousedown', () => {
            // We are not resizing if the img is draggable
            if (this.isDraggable) {
                return;
            }
            this.isResizing = true;
        });

        // On mouse move, resize
        this.$refs.resizableImg.addEventListener('mousemove', (e) => {
            if (!this.isResizing) {
                return;
            }

            // TL;DR: Current movement is larger, img is larger.
            // Current movement is smaller, img is smaller.
            //
            // Using the Pythagorean theorem we are getting the magnitude
            // of the vector/position of the mouse. If it is larger than the
            // previous one, then we make the image larger, and viceversa.
            // This makes the img larger when the mouse is moving to the bottom right of it.
            let movement = Math.sqrt(Math.pow(e.offsetY, 2) + Math.pow(e.offsetX, 2));

            if (this.lastMovement > 0) {
                if (movement > this.lastMovement) {
                    this.resizeAspectRatio(true);
                } else if (movement < this.lastMovement) {
                    this.resizeAspectRatio(false);
                }
            }

            this.lastMovement = movement;
        });

        // We stop resizing when releasing the click button.
        // Caveat: it only works when the mouse is over the img.
        this.$refs.resizableImg.addEventListener('mouseup', () => {
            this.isResizing = false;
            this.lastMovement = 0;
        }); */
    },
    methods: {
        onMouseDown(e) {
            e.preventDefault();
            this.isResizing = true;
            window.addEventListener('mousemove', this.throttle(this.onMouseMove));
            window.addEventListener('mouseup', this.onMouseUp);
        },

        onMouseUp(e) {
            // e.preventDefault();
            this.isResizing = false;
            this.lastMovement = {};
            window.removeEventListener('mousemove', this.throttle(this.onMouseMove));
            window.removeEventListener('mouseup', this.onMouseUp);

        },

        onMouseMove(e) {
            e.preventDefault();
            if (!this.isResizing) {
                return;
            }

            if (!Object.keys(this.lastMovement).length) {
                this.lastMovement = { x: e.x, y: e.y };
                return;
            }

            if (e.x === this.lastMovement.x && e.y === this.lastMovement.y) {
                return;
            }
            let nextX = e.x - this.lastMovement.x;
            let nextY = e.y - this.lastMovement.y;
            const width = this.$refs.resizableImg.width + nextX;
            const height = this.$refs.resizableImg.height + nextY;
            this.lastMovement = { x: e.x, y: e.y };
            this.updateAttributes({ width, height });
        },

        // Returns a function, that, when invoked, will only be triggered at most once
        // during a given window of time. Normally, the throttled function will run
        // as much as it can, without ever going more than once per `wait` duration;
        // but if you'd like to disable the execution on the leading edge, pass
        // `{leading: false}`. To disable execution on the trailing edge, ditto.
        throttle(func, wait, options) {
            var context, args, result;
            var timeout = null;
            var previous = 0;
            if (!options) options = {};
            var later = function () {
                previous = options.leading === false ? 0 : Date.now();
                timeout = null;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            };
            return function () {
                var now = Date.now();
                if (!previous && options.leading === false) previous = now;
                var remaining = wait - (now - previous);
                context = this;
                args = arguments;
                if (remaining <= 0 || remaining > wait) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    previous = now;
                    result = func.apply(context, args);
                    if (!timeout) context = args = null;
                } else if (!timeout && options.trailing !== false) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        }

    }
}

</script>
<style lang="scss" scoped>
.image-container:hover {
    .hidden {
        visibility: visible !important;
    }
}

.image-container {
    overflow: hidden;
    position: relative;
}

.resize-icon {
    position: absolute;
    bottom: 0;
}

::v-deep.resize-icon {
    cursor: se-resize !important;
}
</style>